import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(3.2289 2)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Calendar",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "path1",
					d: "M2.71449 6.32195C2.71449 2.83039 5.54645 0 9.03994 0H24.5021C27.9956 0 30.8276 2.83039 30.8276 6.32195V12.9951C30.8276 16.4867 27.9956 19.3171 24.5021 19.3171H9.03994C5.54645 19.3171 2.71449 16.4867 2.71449 12.9951V6.32195Z",
					fillRule: "evenodd",
					clipRule: "evenodd",
					fill: "#BBE2FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "path2",
					d: "M0.0497224 9.08603C-0.400307 5.66779 2.26209 2.63413 5.71144 2.63413H27.8307C31.2803 2.63413 33.9425 5.66779 33.4924 9.08603L32.1454 19.3171L33.4924 29.5481C33.9425 32.9663 31.2803 36 27.8307 36H5.71144C2.26187 36 -0.400307 32.9663 0.0497224 29.5481L1.39674 19.3171L0.0497224 9.08603Z",
					fillRule: "evenodd",
					clipRule: "evenodd",
					fill: "#3C90FF"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask0_0_21",
					style: { maskType: "alpha" },
					maskUnits: "userSpaceOnUse",
					x: 0,
					y: 2,
					width: 34,
					height: 34,
					children: /* @__PURE__ */ _jsx("path", {
						id: "Mask",
						d: "M0.0497224 9.08603C-0.400307 5.66779 2.26209 2.63413 5.71144 2.63413H27.8307C31.2803 2.63413 33.9425 5.66779 33.4924 9.08603L32.1454 19.3171L33.4924 29.5481C33.9425 32.9663 31.2803 36 27.8307 36H5.71144C2.26187 36 -0.400307 32.9663 0.0497224 29.5481L1.39674 19.3171L0.0497224 9.08603Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask0_0_21)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "path4",
							d: "M-1.45849 36H35.0007V19.3171H-1.45849V36Z",
							fillRule: "evenodd",
							clipRule: "evenodd",
							fill: "url(#paint0_linear_0_21)"
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "path6",
							filter: "url(#filter0_f_0_21)",
							children: /* @__PURE__ */ _jsx("path", {
								d: "M2.71449 4.21463C2.71449 1.88693 4.60246 0 6.93146 0H26.6106C28.9396 0 30.8276 1.88693 30.8276 4.21463V19.3171H2.71449V4.21463Z",
								fillRule: "evenodd",
								clipRule: "evenodd",
								fill: "url(#paint1_linear_0_21)",
								fillOpacity: .6
							})
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "path7",
							d: "M12.2363 27.5128C11.3165 27.5128 10.5275 27.3633 9.86936 27.0643C9.21119 26.7653 8.65405 26.3655 8.19794 25.8647C7.74916 25.3563 7.43128 24.8592 7.24429 24.3735C7.05731 23.8878 6.98256 23.5926 7.02005 23.4878C7.06083 23.3801 7.14097 23.2919 7.24429 23.2411L8.48962 22.7478C8.59416 22.6956 8.69886 22.6881 8.80369 22.7254C8.90824 22.7553 9.0316 22.9272 9.17378 23.2411C9.32342 23.555 9.5328 23.8876 9.80193 24.239C10.0712 24.5767 10.4073 24.8553 10.7892 25.0573C11.1708 25.2516 11.6419 25.3488 12.2025 25.3488C13.1074 25.3488 13.8254 25.0872 14.3565 24.5641C14.8949 24.0409 15.1641 23.3757 15.1641 22.5685C15.1641 21.6939 14.8799 21.0212 14.3114 20.5503C13.7432 20.0719 12.9916 19.8327 12.0567 19.8327H10.879C10.771 19.8345 10.6664 19.7944 10.5873 19.7207C10.5127 19.6385 10.4753 19.5451 10.4751 19.4404V18.2408C10.4751 18.1286 10.5124 18.0351 10.5871 17.9605C10.6633 17.8809 10.7689 17.8363 10.879 17.8371H11.8996C12.7373 17.8371 13.4104 17.6091 13.919 17.1531C14.4275 16.6971 14.6817 16.1066 14.6817 15.3816C14.6817 14.6643 14.4536 14.0851 13.9974 13.644C13.5411 13.2029 12.913 12.9824 12.1129 12.9824C11.6641 12.9824 11.2752 13.0572 10.9462 13.2067C10.6208 13.3534 10.3302 13.5674 10.0936 13.8345C9.85972 14.089 9.65296 14.3671 9.47665 14.6643C9.30475 14.9483 9.16638 15.1053 9.06154 15.1351C8.957 15.1575 8.85604 15.1389 8.75867 15.0792L7.58077 14.5073C7.48355 14.4549 7.42 14.3727 7.39013 14.2606C7.36026 14.1485 7.45002 13.8869 7.6594 13.4758C7.87625 13.0573 8.20526 12.6312 8.64643 12.1976C9.08909 11.7603 9.61573 11.417 10.1946 11.1885C10.7854 10.9493 11.4735 10.8298 12.2587 10.8298C13.7171 10.8298 14.8725 11.2147 15.725 11.9845C16.5776 12.7469 17.0039 13.756 17.0039 15.0118C17.0039 15.8788 16.7945 16.63 16.3758 17.2653C15.9643 17.9004 15.381 18.3489 14.6257 18.6109V18.6557C15.5381 18.9246 16.256 19.4179 16.7795 20.1354C17.3105 20.8456 17.576 21.6939 17.5759 22.6804C17.5759 24.0932 17.0823 25.2518 16.0951 26.1562C15.1082 27.0606 13.8219 27.5128 12.2361 27.5128H12.2363ZM23.4926 27.255C23.3655 27.255 23.2532 27.2063 23.1559 27.1091C23.0674 27.0152 23.0192 26.8905 23.0215 26.7616V14.2942L20.4974 16.1104C20.4075 16.1777 20.3028 16.2002 20.1831 16.1778C20.0753 16.1581 19.9791 16.0979 19.9141 16.0097L19.1849 14.978C19.1192 14.8873 19.0911 14.7749 19.1063 14.6641C19.1287 14.5446 19.1885 14.4513 19.2857 14.384L23.7616 11.1885C23.7991 11.1587 23.8402 11.1363 23.8851 11.1214C23.93 11.099 23.9824 11.0878 24.0421 11.0878H24.9845C25.1116 11.0878 25.2126 11.1326 25.2874 11.2223C25.3697 11.3043 25.4108 11.4089 25.4108 11.5362V26.7616C25.4108 26.8962 25.3622 27.0121 25.265 27.1091C25.1794 27.2044 25.0564 27.2577 24.9283 27.255H23.4926Z",
							fill: "white"
						})
					]
				})
			]
		}), /* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_0_21",
				x: -9.24363,
				y: -11.9581,
				width: 52.0293,
				height: 43.2333,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 5.97906,
						result: "effect1_foregroundBlur_0_21"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_0_21",
				x1: 16.7711,
				y1: 19.3171,
				x2: 16.7711,
				y2: 36,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4FA0FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#3186FF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_0_21",
				x1: 15.2468,
				y1: 3.01829,
				x2: 15.2468,
				y2: 19.4027,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A9A8FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: .8,
					stopColor: "#3C90FF"
				})]
			})
		] })]
	})
});
export default SvgGoogleCalendar;
